import { Injectable } from '@angular/core';
import { OrderService } from '@services/order.service';

/**
 * Base order service for sites that reload the cart when an in-home collection booking is submitted.
 */
@Injectable()
export abstract class InHomeBookingReloadOrderService extends OrderService {
  public constructor() {
    super();
    this.listenForBookingSubmission();
  }

  /**
   * Reloads the cart when an in-home collection booking is submitted.
   */
  protected abstract listenForBookingSubmission(): void;
}
